const styles = (theme) => ({
  messageCard: {
    borderColor: theme.palette.primary.main,
    borderWidth: '3px',
    borderRadius: 0,
  },
  outageCard: {
    borderColor: theme.palette.error.main,
    borderWidth: '3px',
    borderRadius: 0,
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  outage: {
    background: theme.palette.background.lighter,
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    borderWidth: '3px',
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  message: {
    background: theme.palette.background.lighter,
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    borderWidth: '3px',
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  headerCollapsed: {
    paddingBottom: theme.spacing.unit * 3,
  },
  headerExpanded: {},
  dividerExpanded: {
    marginTop: `-${theme.spacing.unit * 0.75}px`,
    [theme.breakpoints.up('md')]: {
      marginTop: `-${theme.spacing.unit * 0.5}px`,
    },
  },
  contentContainer: {
    '& > div': {
      fontSize: '0.9375rem',
      paddingTop: theme.spacing.unit * 2,
      [theme.breakpoints.up('md')]: {
        fontSize: '1.1875rem',
      },
    },
  },
});

export default styles;
